import { createStaticParty } from '../../api/staticParty';
import { navigate } from '../../router';
import { showToast } from '../../toast';

/**
 * "Créer une lounge party" - shared by views/series (whole series, or
 * the selected season) and views/playlist: creates a lounge party over
 * the source id (a series, a season or a video playlist - the server
 * decides which, and refuses anything else with a message) and opens its
 * page. `sourceId` is read at click time, so a caller whose source can
 * change (the selected season tab) wires the button only once.
 */
export function wireCreateStaticButton(btn: HTMLButtonElement, getSourceId: () => string): void {
  const idleLabel = btn.textContent || '';
  btn.addEventListener('click', () => {
    const sourceId = getSourceId();
    btn.disabled = true;
    btn.textContent = 'Création...';
    createStaticParty(sourceId)
      .then((sp) => {
        console.info('[staticParty] created', sp.id, 'from', sourceId);
        navigate(`/static/${sp.id}`);
      })
      .catch((err: unknown) => {
        console.error('[staticParty] create failed', sourceId, err);
        showToast((err as Error).message, { variant: 'error' });
        btn.disabled = false;
        btn.textContent = idleLabel;
      });
  });
}
